export default {
      id: "ic_in-browser-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_in-browser",
      toString: function () {
        return this.url;
      }
    }